<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="header-row flex flex-justify-space-between flex-align-center">
          <span>{{ 'addresses.list.title' | translate }}</span>
          <app-button data-testid="new-address-button" variant="filled" routerLink="/map/addresses/new"
            *hasPermission="'address.create'">
            <app-icon name="plus" /> {{ 'addresses.list.new' | translate }}
          </app-button>
        </div>
      </app-card-title>
    </app-card-header>

    <app-card-content>
      <form [formGroup]="searchForm" class="search-form">
        <formly-form [form]="searchForm" [fields]="searchFields" [model]="searchModel" />
      </form>

      @if (loading()) {
        <div class="loading-container flex flex-column flex-align-center p-lg">
          <app-spinner />
        </div>
      } @else if (error()) {
        <div class="error-container p-lg" data-testid="addresses-error">
          <p>{{ 'addresses.list.loadError' | translate }}</p>
        </div>
      } @else if (addresses().length === 0) {
        <div class="empty-state p-lg" data-testid="addresses-empty-state">
          <app-icon name="map-pin" [size]="48" />
          <h3>{{ 'addresses.list.empty.title' | translate }}</h3>
          <p>{{ 'addresses.list.empty.description' | translate }}</p>
        </div>
      } @else if (filtered().length === 0) {
        <div class="empty-state p-lg" data-testid="addresses-no-match">
          <app-icon name="search" [size]="48" />
          <h3>{{ 'addresses.list.noMatch.title' | translate }}</h3>
        </div>
      } @else {
        <ul class="address-list" data-testid="address-list">
          @for (address of filtered(); track address.id) {
            <li class="address-row">
              <a [routerLink]="['/map/addresses', address.id]" class="address-link"
                [attr.data-testid]="'address-row-' + address.id">
                <div class="address-main flex flex-justify-space-between flex-align-center gap-sm">
                  <div class="address-text flex flex-column gap-xs">
                    <span class="address-formatted">{{ address.formatted_address }}</span>
                    @if (address.business_name) {
                      <span class="address-business">{{ address.business_name }}</span>
                    }
                  </div>
                  <div class="address-badges flex flex-align-center gap-xs">
                    @if (address.do_not_contact) {
                      <app-icon name="ban" [size]="18" class="dnc-icon"
                        [attr.data-testid]="'address-dnc-' + address.id" />
                    }
                    @if (address.last_outcome_kind) {
                      <app-outcome-chip [outcome]="address.last_outcome_kind" [objectionId]="address.last_objection_id" />
                    }
                  </div>
                </div>
                @if (address.last_interaction_at) {
                  <span class="address-meta">{{ address.last_interaction_at | relativeTime: now() }}</span>
                } @else if (address.notes) {
                  <span class="address-meta">{{ address.notes }}</span>
                }
              </a>
            </li>
          }
        </ul>
      }
    </app-card-content>
  </app-card>
</div>
